<template>
  <div
    v-if="teacher"
    class="d-flex flex-row align-center"
    :key="teacher.id"
    @click="$emit('change', teacher)"
  >
    <v-avatar class="my-2 mr-2" size="34">
      <v-img :src="avatar" />
    </v-avatar>
    <router-link class="teacher-link" :to="getLink">
      <div
        class="teacher-name"
        :class="{
          'teacher-link-disabled': ![
            'education_manager',
            'accountant',
            'manager',
            'super_admin'
          ].includes(role.type)
        }"
      >
        {{ teacher.name }}
      </div>
    </router-link>
  </div>
  <div v-else>Không có thông tin</div>
</template>
<script>
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
  props: {
    teacher: Object,
    prepend: Object,
    append: Object,
    attendance: Object,
    link: Boolean
  },
  computed: {
    ...mapState('auth', ['user', 'role']),
    avatar() {
      return _.get(this.data, 'avatar.url', '/default-avatar.png')
    },
    getLink() {
      if (!['manager', 'education_manager', 'super_admin'].includes(this.role.type)) return ''
      return '/teacher/' + this.teacher.id
    }
  }
}
</script>

<style scoped>
.teacher-link {
  text-decoration: none;
}
.teacher-link-disabled {
  color: black;
}
.teacher-name {
  white-space: nowrap;
}
</style>
